module.exports = __webpack_public_path__ + "img/zdgl_charact_6.3d30fb6c.svg";